// src/LoginPage.js
import React, { useState } from 'react';

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();

    // IMPORTANT: These are your hardcoded credentials.
    // You can change them to whatever you like.
    const validUsername = 'inspectorate'; // This is the correct username
    const validPassword = 'wales2025'; // This is the correct password

    if (username === validUsername && password === validPassword) {
      // Store login status in sessionStorage
      sessionStorage.setItem('isAuthenticated', 'true');
      onLogin();
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Please Log In</h1>
      <p>This website is currently private. Please enter the credentials to view it.</p>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">Username: </label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ margin: '5px' }}
          />
        </div>
        <div>
          <label htmlFor="password">Password: </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ margin: '5px' }}
          />
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit" style={{ marginTop: '10px' }}>Login</button>
      </form>
    </div>
  );
};

export default LoginPage;
